import { render, staticRenderFns } from "./updata-stop-reason.vue?vue&type=template&id=24d0aab3"
import script from "./updata-stop-reason.vue?vue&type=script&lang=ts"
export * from "./updata-stop-reason.vue?vue&type=script&lang=ts"
import style0 from "./updata-stop-reason.vue?vue&type=style&index=0&id=24d0aab3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports